module.exports = __webpack_public_path__ + "img/2_214.4ecdf008.png";